export interface Idata {
    Nummer: string
    Navn: string
    Indmeldelsesdato: string
}

export class Department {
    id = ''

    name = ''

    registrationDate: Date | undefined = undefined

    static build(data: Idata): Department {
        const department = new Department()

        department.id = data.Nummer
        department.name = data.Navn
        department.registrationDate = data.Indmeldelsesdato
            ? new Date(data.Indmeldelsesdato)
            : undefined

        return department
    }
}

export function mapDepartments(data: Idata[]): Department[] {
    return data.map((department) => Department.build(department))
}
